
import React from 'react';
import '../../../install/style.less'
import './style.less';

interface IProps {
    children: React.ReactNode;
}

const esayDeployQuick: React.FC<IProps> = (props) => {
    return <div className="easy-deploy-quick">
        <div className="easy-deploy-quick-title">
            开始安装
        </div>
        <div className="easy-deploy-quick-desc">
            用FastDeploy部署你的大模型
        </div>
        {props.children}
    </div>
}

export default esayDeployQuick;